import { useEffect, useState } from 'react';
import type { EmojiCatalogModuleState } from '../types/emoji-picker.types';

/**
 * Loads the native catalog only when its owning picker is mounted.
 * @returns Component, recoverable loading state and explicit retry action.
 */
export const useEmojiCatalogModule = () => {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<EmojiCatalogModuleState>({
    failed: false,
  });

  useEffect(() => {
    let active = true;
    setState({ failed: false });
    void import('../components/molecules/emoji-picker/emoji-catalog').then(
      ({ EmojiCatalog }) => {
        if (active) setState({ Catalog: EmojiCatalog, failed: false });
      },
      (error: unknown) => {
        if (!active) return;
        console.error('Emoji catalog module failed to load', { error });
        setState({ failed: true });
      }
    );
    return () => {
      active = false;
    };
  }, [attempt]);

  return { ...state, retry: () => setAttempt((current) => current + 1) };
};
